export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-3.47c4734e.jpg";